import React, { Component } from "react";
import PropTypes from "prop-types";
import MyFontList from "./MyFontList";
import GoogleFontList from "./GoogleFontList";
import { connect } from "react-redux";
import _ from "lodash";
import { FONT_CACHE } from "../../../constants";
import {
  Button,
  ButtonGroup,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Flex,
  Divider,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { fetchFonts, resetFonts } from "apps/simplified-web/src/_actions/appActions";
import axios from "axios";

class TLDRBrowseMoreFontsModal extends Component {
  signal = axios.CancelToken.source();
  render() {
    const { show, onHide, canvasRef, t } = this.props;

    return (
      <Modal isOpen={show} isCentered onClose={this.onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("google_fonts")}</ModalHeader>
          <Divider my="1" />
          <ModalCloseButton />

          <ModalBody p="0">
            <Flex
              direction="row"
              minH="calc(100vh * 0.6)"
              m="1rem"
              overflowY="hidden"
            >
              <GoogleFontList canvasRef={canvasRef} />
              <MyFontList />
            </Flex>
          </ModalBody>
          <Divider my="1" />

          <ModalFooter>
            <ButtonGroup>
              <Button onClick={this.onCancelClick} variant="secondary">
                {t("cancel")}
              </Button>
              <Button onClick={this.onFinishClick} variant="solid">
                {t("finish")}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
  
  onClose = () => {
    this.props.resetFonts();
    // this.props.fetchFonts(this.props, this.signal);
    this.props.onHide();
  }
  
  onCancelClick = (event) => {
    event.stopPropagation();
    this.removeLoadedButNotInUseFontStyle();
    this.props.onHide();
  };

  onFinishClick = (event) => {

    event.stopPropagation();
    this.removeLoadedButNotInUseFontStyle();
    this.props.onHide();
  };

  removeLoadedButNotInUseFontStyle = async () => {
    for (let fontFamilyKey in FONT_CACHE) {
      let isFontInList =
        _.findIndex(this.props.fonts, { family: fontFamilyKey }) > -1;

      // If font isn't in list then remove from the cache and head styling
      // Do not delete Rubik font as it is being used in Appication wide
      if (!isFontInList && fontFamilyKey !== "Rubik") {
        delete FONT_CACHE[fontFamilyKey];
        let fontFamilyTag = document.getElementById(fontFamilyKey);
        if (fontFamilyTag) {
          fontFamilyTag.remove();
        }
        // document.getElementById(fontFamilyKey).remove();
      }
    }
  };
}

TLDRBrowseMoreFontsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

TLDRBrowseMoreFontsModal.defaultProps = {
  show: false,
};

const mapStateToProps = (state) => ({
  fonts: state.app.fonts,
});

const mapDispatchToProps = (dispatch) => ({
  fetchFonts: (props, cancelToken) => dispatch(fetchFonts(props, cancelToken)),
  resetFonts: () => dispatch(resetFonts())
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(TLDRBrowseMoreFontsModal)
);
